var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".8","stroke":"#17161E","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M16.125 19.25l6.25-6.25-6.25-6.25M3.625 13h17.7083M22.3747 13H21.333"})));
}

Arrow.defaultProps = {"fill":"none","viewBox":"0 0 26 26"};

module.exports = Arrow;

Arrow.default = Arrow;
